export const RENTER_VIEW_PAYMENT = "RENTER_VIEW_PAYMENT"
export const RENTER_VIEW_PAYMENT_SUCCESSFUL = "RENTER_VIEW_PAYMENT_SUCCESSFUL"
export const RENTER_VIEW_PAYMENT_FAILED = "RENTER_VIEW_PAYMENT_FAILED"